import { clsx } from 'clsx';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { LinkElementType } from '@interxfi/design-system/components/link/base-link';
import { TextLink } from '@interxfi/design-system/components/link/text-link/text-link';
import { Typography } from '@interxfi/design-system/components/typography';
import { AssetLogo, type AssetLogoSize } from '../asset-logo';
import { AssetLogoPlaceholder } from '../placeholder/asset-logo-placeholder';
import { AssetLogoWithLabelSkeleton } from './asset-logo-with-label-skeleton';
import styles from './asset-logo-with-label.module.scss';

interface AssetLogoWithLabelProps {
  alt: string | undefined;
  isPending?: boolean;
  label: string | undefined;
  LinkElement?: LinkElementType;
  logoSrc: string | undefined;
  placeholderSymbol?: string;
  size?: AssetLogoSize;
  to?: string;
}

export function AssetLogoWithLabel({ alt, isPending, label, LinkElement, logoSrc, placeholderSymbol, size = 'small', to }: AssetLogoWithLabelProps) {
  if (isPending) {
    return <AssetLogoWithLabelSkeleton size={size} />;
  }

  return (
    <HorizontalStack blockAlign="center" className={clsx(styles.assetLogoWithLabel, `size-${size}`)} gap={2} wrap="nowrap">
      <AssetLogo
        alt={alt}
        placeholder={placeholderSymbol !== undefined ? <AssetLogoPlaceholder size={size} symbol={placeholderSymbol} /> : undefined}
        placeholderBorder={false}
        size={size}
        src={logoSrc}
      />
      {to && LinkElement ? (
        <TextLink LinkElement={LinkElement} to={to}>
          {label}
        </TextLink>
      ) : (
        <Typography>{label}</Typography>
      )}
    </HorizontalStack>
  );
}
